import { ApiImportPreviewOverview } from "@/types/import-data.types.ts";
import { Box, Stack, Table, Text, Title } from "@skailer-com/uikit";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface ImportDataPreviewTableProps {
  previewOverview: ApiImportPreviewOverview;
}

type PreviewRow = Record<string, string>;

export function ImportDataPreviewTable({ previewOverview }: ImportDataPreviewTableProps) {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<PreviewRow>();

  const columns = useMemo<ColumnDef<PreviewRow>[]>(() => {
    return previewOverview.preview.columns.map(({ column_index, header }) =>
      columnHelper.accessor(String(column_index), {
        header: header,
        cell: (cell) => <Text className={"text-default text-title"}>{cell.getValue()}</Text>,
      })
    ) as ColumnDef<PreviewRow>[];
  }, [previewOverview.preview.columns]);

  const tableData = useMemo<PreviewRow[]>(() => {
    return previewOverview.preview.rows.map((row) => {
      const rowObj: PreviewRow = {};
      row.forEach((cell, index) => {
        const columnIndex = previewOverview.preview.columns[index]?.column_index;
        if (columnIndex !== undefined) {
          rowObj[String(columnIndex)] = cell;
        }
      });
      return rowObj;
    });
  }, [previewOverview.preview.rows, previewOverview.preview.columns]);

  return (
    <Stack>
      <Title header={t("import_data:file_preview")} size={"xs"} />
      <Box className={"overflow-x-auto"}>
        <Table data={tableData} columns={columns} />
      </Box>
    </Stack>
  );
}
